import React from 'react';
import OrderUpdate from "../../components/admin/purchase_order/components/OrderUpdate";
import PersistentDrawerLeft from "../../components/reusable/admin/Main";
const PurchaseOrderEdit = () => {
  return (
    <div>
      <PersistentDrawerLeft>
        <OrderUpdate />
      </PersistentDrawerLeft>
    </div>
  );
};

export default PurchaseOrderEdit;